@import "../../../styles/base";

.c-divider {
  display: flex;
  align-items: center;
  margin: 1.5rem 0;

  &--tight {
    margin: 1rem 0;
  }

  &__label {
    flex: 1 0 auto;
    padding: 0 1rem;
    font-size: $ds-font-size-b3;
    font-weight: $ds-font-weight-medium;
    text-align: center;
    text-transform: uppercase;
    color: $ds-neutral-700;
  }

  &::before,
  &::after {
    content: "";
    flex: 0 1 auto;
    width: 50%;
    height: 1px;
    background: $ds-neutral-200;
  }
}
